/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "encoded",
                type: "bytes32",
            },
        ],
        name: "decode",
        outputs: [
            {
                components: [
                    {
                        internalType: "enum EnrollmentStatus",
                        name: "status",
                        type: "EnrollmentStatus",
                    },
                    {
                        internalType: "uint248",
                        name: "unenrollmentStartBlock",
                        type: "uint248",
                    },
                ],
                internalType: "struct Enrollment",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "enum EnrollmentStatus",
                        name: "status",
                        type: "EnrollmentStatus",
                    },
                    {
                        internalType: "uint248",
                        name: "unenrollmentStartBlock",
                        type: "uint248",
                    },
                ],
                internalType: "struct Enrollment",
                name: "enrollment",
                type: "tuple",
            },
        ],
        name: "encode",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
];
const _bytecode = "0x6103aa61003a600b82828239805160001a60731461002d57634e487b7160e01b600052600060045260246000fd5b30600052607381538281f3fe73000000000000000000000000000000000000000030146080604052600436106100405760003560e01c80632d6b741714610045578063c3748ef11461006b575b600080fd5b6100586100533660046101c6565b61008b565b6040519081526020015b60405180910390f35b61007e610079366004610274565b610128565b60405161006291906102bc565b805160009060028111156100a1576100a161028d565b60208084015160405161010a93920160f89290921b7fff0000000000000000000000000000000000000000000000000000000000000016825260081b7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0016600182015260200190565b6040516020818303038152906040526101229061032f565b92915050565b604080518082019091526000808252602082015260408051808201909152600083901a907effffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff841690808360028111156101825761018261028d565b60028111156101935761019361028d565b8152602001827effffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff1681525092505050919050565b6000604082840312156101d857600080fd5b6040516040810181811067ffffffffffffffff82111715610222577f4e487b7100000000000000000000000000000000000000000000000000000000600052604160045260246000fd5b60405282356003811061023457600080fd5b815260208301357effffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff8116811461026857600080fd5b60208201529392505050565b60006020828403121561028657600080fd5b5035919050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052602160045260246000fd5b81516040820190600381106102fa577f4e487b7100000000000000000000000000000000000000000000000000000000600052602160045260246000fd5b808352507effffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff602084015116602083015292915050565b8051602080830151919081101561036e577fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff8160200360031b1b821691505b5091905056fea2646970667358221220f18c31e138ababd5855da4e112506f87def12145e26ade71e525ff490075baa664736f6c63430008130033";
const isSuperArgs = (xs) => xs.length > 1;
export class EnumerableMapEnrollment__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
//# sourceMappingURL=EnumerableMapEnrollment__factory.js.map